import { render, staticRenderFns } from "./Gateway.vue?vue&type=template&id=68ccfd0e&scoped=true"
import script from "./Gateway.vue?vue&type=script&lang=js"
export * from "./Gateway.vue?vue&type=script&lang=js"
import style0 from "./Gateway.vue?vue&type=style&index=0&id=68ccfd0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ccfd0e",
  null
  
)

export default component.exports